import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Contact, ContactStatus, ContactType } from '@src/api/types/contact';
import { Pagination } from '@src/api/types/pagination';
import { IndexRequest } from '@src/api/types/shared/request';

export type ContactIndexRequest = IndexRequest & {
  contact_type?: ContactType;
  status?: ContactStatus;
};

export type ContactIndexResponse = {
  data: Contact[];
  pagination: Pagination;
};

export type ContactCsvExportRequest = {
  contact_type?: ContactType;
  status?: ContactStatus;
  sort?: string;
  direction?: string;
};

export type ContactStatusUpdateResponse = {
  id: number;
  status: ContactStatus;
};

export type ContactStatusUpdateErrorResponse = {
  status: string[];
};

export type ContactMemoUpdateResponse = {
  id: number;
  memo: string | null;
};

export type ContactMemoUpdateErrorResponse = {
  memo: string[];
};

export const contactApiClient = {
  index: async (params: ContactIndexRequest = {}): Promise<ApiResult<ContactIndexResponse>> => {
    return await axiosClient.get('/tenant/contacts', { params });
  },
  updateStatus: async (
    id: number,
    status: ContactStatus,
  ): Promise<ApiResult<ContactStatusUpdateResponse, ContactStatusUpdateErrorResponse>> => {
    return await axiosClient.put(`/tenant/contacts/${id}/status`, { status });
  },

  updateMemo: async (
    id: number,
    memo: string,
  ): Promise<ApiResult<ContactMemoUpdateResponse, ContactMemoUpdateErrorResponse>> => {
    return await axiosClient.put(`/tenant/contacts/${id}/memo`, { memo });
  },

  show: async (id: number): Promise<ApiResult<Contact>> => {
    return await axiosClient.get(`/tenant/contacts/${id}`);
  },

  exportCsv: async (params: ContactCsvExportRequest = {}): Promise<ApiResult<Blob, never>> => {
    return await axiosClient.get('/tenant/contacts/csv-export', {
      params,
      responseType: 'blob',
    });
  },
};
